// dashboardStyles.js - Updated to support 5 column origins layout
export const dashboardStyles = {
    container: {
        width: '100%',
        padding: '16px',
        margin: '0'
    },

    // FIXED: Full width grid layout - no empty space on right
    dashboardGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, minmax(180px, 1fr))',
        gridTemplateRows: 'auto auto',
        gap: '16px',
        alignItems: 'start',
        marginBottom: '16px',
        width: '100%'
    },

    module: {
        background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
        border: '1px solid transparent',
        borderRadius: '12px',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.3s ease'
    },

    // Compact Metric Modules
    metricModule: {
        padding: '12px 10px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        minHeight: '100px',
        maxHeight: '100px'
    },
    metricIcon: {
        width: '32px',
        height: '32px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '8px',
        fontSize: '16px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)'
    },
    metricValue: {
        fontSize: '20px',
        fontWeight: '800',
        marginBottom: '4px',
        background: 'linear-gradient(135deg, #ffffff, #e2e8f0)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        letterSpacing: '-0.5px',
        lineHeight: '1'
    },
    metricLabel: {
        color: '#94a3b8',
        fontSize: '11px',
        fontWeight: '500',
        letterSpacing: '0.3px'
    },

    // ✅ UPDATED: Origins Module with 5 column support
    originsModule: {
        background: 'linear-gradient(135deg, #334155 0%, #1e293b 100%)',        
        border: '1px solid rgba(139, 92, 246, 0.2)',
        borderRadius: '12px',
        padding: '14px',
        gridColumn: '1 / 5',
        gridRow: '2',
        boxShadow: '0 6px 24px rgba(0, 0, 0, 0.4)'
    },
    sidsSnapshotModule: {
        background: 'linear-gradient(135deg, #334155 0%, #1e293b 100%)',
        border: '1px solid rgba(34, 197, 94, 0.2)',
        borderRadius: '12px',
        padding: '14px',
        gridColumn: '1 / 5',
        gridRow: '3',
        boxShadow: '0 6px 24px rgba(0, 0, 0, 0.4)'
    },
    timeWindowModule: {
        background: 'linear-gradient(135deg, #1f2937 0%, #111827 100%)',
        border: '1px solid rgba(59, 130, 246, 0.25)',
        borderRadius: '12px',
        padding: '12px',
        gridColumn: '4',
        gridRow: '1',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        boxShadow: '0 6px 24px rgba(0, 0, 0, 0.35)'
    },
    timeWindowHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '8px'
    },
    timeWindowTitle: {
        color: '#e2e8f0',
        fontSize: '13px',
        fontWeight: '600'
    },
    timeWindowSubtitle: {
        color: '#94a3b8',
        fontSize: '10px',
        fontWeight: '500'
    },
    timeWindowButtons: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '8px'
    },
    timeWindowButton: {
        border: '1px solid rgba(148, 163, 184, 0.25)',
        background: 'rgba(15, 23, 42, 0.7)',
        color: '#cbd5f5',
        borderRadius: '8px',
        padding: '8px 10px',
        fontSize: '11px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    timeWindowButtonActive: {
        background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
        borderColor: 'rgba(59, 130, 246, 0.7)',
        color: '#f8fafc',
        boxShadow: '0 6px 16px rgba(37, 99, 235, 0.35)'
    },
    timeWindowHint: {
        color: '#7dd3fc',
        fontSize: '9px',
        letterSpacing: '0.4px',
        textTransform: 'uppercase'
    },
    originsHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        marginBottom: '10px'
    },
    originsIcon: {
        width: '20px',
        height: '20px',
        background: '#8b5cf6',
        borderRadius: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '11px'
    },
    originsTitle: {
        color: '#e2e8f0',
        fontSize: '18px',
        fontWeight: '600'
    },
    // ✅ UPDATED: Origins list now supports 5 columns by default
    originsList: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)', // ✅ Default to 5 columns
        gap: '8px' // ✅ Reduced gap for tighter layout
    },
    originsColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px' // ✅ Reduced gap between items
    },
    originItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '3px 5px', // ✅ Slightly increased padding
        background: 'rgba(15, 23, 42, 0.6)',
        border: '1px solid rgba(139, 92, 246, 0.1)',
        borderRadius: '4px', // ✅ Slightly smaller border radius
        transition: 'all 0.3s ease',
        minHeight: '20px' // ✅ Increased minimum height
    },
    originName: {
        color: '#e2e8f0',
        fontSize: '15px',        // ← Changed from 10px to 15px (+5px)
        fontWeight: '500',
        flex: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    originCount: {
        color: '#8b5cf6',
        fontSize: '15px',        // ← Changed from 10px to 15px (+5px)
        fontWeight: '600',
        marginLeft: '4px',
        minWidth: '30px',
        textAlign: 'right'
    },

    // Compact System Status Module
    systemModule: {
        background: 'linear-gradient(135deg, #334155 0%, #1e293b 100%)',
        border: '1px solid rgba(148, 163, 184, 0.2)',
        borderRadius: '12px',
        padding: '16px',
        gridColumn: '4',
        gridRow: '1 / 3',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxShadow: '0 6px 24px rgba(0, 0, 0, 0.4)'
    },
    systemHeader: {
        textAlign: 'center',
        marginBottom: '12px'
    },
    systemIcon: {
        width: '32px',
        height: '32px',
        background: '#ef4444',
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        margin: '0 auto 6px'
    },
    systemTitle: {
        color: '#e2e8f0',
        fontSize: '13px',
        fontWeight: '600',
        marginBottom: '3px'
    },
    systemName: {
        color: '#94a3b8',
        fontSize: '10px',
        fontWeight: '500'
    },
    systemNav: {
        display: 'flex',
        justifyContent: 'center',
        gap: '3px',
        marginBottom: '16px'
    },
    navBtn: {
        width: '20px',
        height: '20px',
        background: 'rgba(59, 130, 246, 0.2)',
        border: '1px solid #3b82f6',
        borderRadius: '3px',
        color: '#3b82f6',
        fontSize: '11px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.3s ease'
    },
    systemStatsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '10px',
        marginBottom: '16px'
    },
    statCard: {
        textAlign: 'center'
    },
    statValue: {
        fontSize: '16px',
        fontWeight: '700',
        marginBottom: '2px',
        lineHeight: '1'
    },
    statLabel: {
        color: '#94a3b8',
        fontSize: '8px',
        fontWeight: '500',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },
    uptimeSection: {
        textAlign: 'center',
        marginBottom: '16px',
        padding: '6px 0'
    },
    uptimeValue: {
        fontSize: '13px',
        fontWeight: '600',
        color: '#ffffff',
        marginBottom: '2px'
    },
    restartBtn: {
        width: '100%',
        background: 'linear-gradient(135deg, #1e293b, #0f172a)',
        border: '1px solid #ffffff',
        borderRadius: '6px',
        padding: '8px 10px',
        color: '#ffffff',
        fontSize: '10px',
        fontWeight: '700',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },

    // Compact Services Module
    servicesModule: {
        background: 'linear-gradient(135deg, #334155 0%, #1e293b 100%)',
        border: '1px solid rgba(148, 163, 184, 0.2)',
        borderRadius: '12px',
        padding: '16px',
        gridColumn: '1 / 4',
        gridRow: '3',
        boxShadow: '0 6px 24px rgba(0, 0, 0, 0.4)'
    },
    servicesHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px'
    },
    servicesInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    servicesIcon: {
        width: '32px',
        height: '32px',
        background: '#f59e0b',
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px'
    },
    servicesTitle: {
        color: '#e2e8f0',
        fontSize: '14px',
        fontWeight: '600',
        marginBottom: '2px'
    },
    serviceEnvName: {
        color: '#94a3b8',
        fontSize: '11px',
        fontWeight: '500'
    },
    servicesGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '12px'
    },
    serviceCard: {
        background: 'rgba(15, 23, 42, 0.6)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '10px',
        padding: '16px',
        textAlign: 'center',
        transition: 'all 0.3s ease'
    },
    serviceName: {
        color: '#e2e8f0',
        fontSize: '13px',
        fontWeight: '500',
        marginBottom: '10px'
    },
    serviceStatusIndicator: {
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        margin: '0 auto',
        transition: 'all 0.3s ease'
    },

    // Compact Account Status Module
    accountModule: {
        background: 'linear-gradient(135deg, #334155 0%, #1e293b 100%)',
        border: '1px solid rgba(239, 68, 68, 0.2)',
        borderRadius: '12px',
        padding: '14px',
        gridColumn: '4',
        gridRow: '3',
        boxShadow: '0 6px 24px rgba(0, 0, 0, 0.4)',
        width: '100%'
    },
    accountHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        marginBottom: '12px'
    },
    accountIcon: {
        width: '20px',
        height: '20px',
        background: '#ef4444',
        borderRadius: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px'
    },
    accountTitle: {
        color: '#e2e8f0',
        fontSize: '13px',
        fontWeight: '600'
    },
    accountStatus: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '6px 0',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
    },
    trunkSection: {
        background: 'rgba(15, 23, 42, 0.4)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '6px',
        padding: '8px',
        marginTop: '8px'
    },
    trunkTitle: {
        color: '#fbbf24',
        fontSize: '10px',
        fontWeight: '600',
        marginBottom: '4px',
        textTransform: 'uppercase'
    },
    trunkRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '3px'
    },
    trunkLabel: {
        color: '#94a3b8',
        fontSize: '9px'
    },
    trunkValue: {
        color: '#e2e8f0',
        fontSize: '10px',
        fontWeight: '600'
    },

    // FIXED: Destinations Module - uses full width of 5th column
    destinationsModule: {
        background: 'linear-gradient(135deg, #334155 0%, #1e293b 100%)',        
        border: '1px solid rgba(245, 158, 11, 0.2)',
        borderRadius: '12px',
        padding: '16px',
        gridColumn: '5',
        gridRow: '1 / 3',
        display: 'flex',
        flexDirection: 'column',
        height: 'fit-content',
        maxHeight: '420px',
        width: '100%', // Use full width of the grid column
        boxShadow: '0 6px 24px rgba(0, 0, 0, 0.4)'
    },
    destinationsHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '12px'
    },
    destinationsIcon: {
        width: '24px',
        height: '24px',
        borderRadius: '6px',
        background: 'linear-gradient(135deg, #f59e0b, #d97706)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px'
    },
    destinationsTitle: {
        color: '#e2e8f0',
        fontSize: '14px',
        fontWeight: '600'
    },
    destinationsValue: {
        fontSize: '28px',
        fontWeight: '900',
        color: '#f59e0b',
        marginBottom: '16px',
        textAlign: 'right',
        marginTop: '-6px'
    },
    destinationsStats: {
        display: 'flex',
        gap: '6px',
        marginBottom: '16px'
    },
    destinationStatCard: {
        flex: '1',
        background: 'rgba(15, 23, 42, 0.6)',
        border: '1px solid rgba(245, 158, 11, 0.2)',
        borderRadius: '6px',
        padding: '6px',
        textAlign: 'center'
    },
    destinationStatNumber: {
        fontSize: '14px',
        fontWeight: '700',
        color: '#f59e0b',
        marginBottom: '1px'
    },
    destinationStatLabel: {
        fontSize: '8px',
        color: '#64748b',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },
    countryList: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '2px 12px',
        flex: '1',
        overflow: 'auto',
        maxHeight: '280px'
    },
    countryItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '3px 0',
        borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
        minHeight: '20px'
    },
    countryName: {
        color: '#e2e8f0',
        fontSize: '11px',
        fontWeight: '400',
        flex: '1',
        textAlign: 'left'
    },
    countryPercent: {
        color: '#f59e0b',
        fontSize: '11px',
        fontWeight: '600',
        marginLeft: '8px',
        minWidth: '30px',
        textAlign: 'right'
    }
};
